import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";

//import AuthService from "../../services/auth.service";
import "./Regulator.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import RegulatorService from "../../services/regulator.service";
///////// react bootstrap////////
import { Form, Row, Col } from "react-bootstrap";
//MUI
import {
  Modal as Modal_MUI,
  Box,
  Typography,
  Button,
  Divider,
  Paper,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
} from "@mui/material";
//// prime react
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import "./prime_edit.css";

//icon
import { FaUserAstronaut } from "react-icons/fa";
import { MdDateRange } from "react-icons/md";
import { FaRegFileLines } from "react-icons/fa6";
import fileicon from "../../picture/file-icon.png";
// import docgif from "../../picture/document-office.gif";
import docgif from "../../picture/search.gif";
import payment from "../../picture/payment.gif";
import Pilot_Status_Regulator from "../../Style_Component/Steps/User_Pilot_Status";

/////Component
import Static_modal from "../user/etc/Static_modal";
import zIndex from "@mui/material/styles/zIndex";
export default function CaatPilotApproval() {
  const [data, setData] = useState([]);
  const [pilot_StatusObject, setPilot_StatusObject] = useState([]);
  const [selectedValueStatus, setSelectedValueStatus] = useState("");
  const [userInformation, setUserInformation] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState(null);
  const [needComment, setNeedComment] = useState(false);
  const [comment, setComment] = useState(null);
  ///Modal setting
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  const handleClose_Modal = (close) => {
    setUserInformation(false);
    setModalToggle(
      {
        ...modalToggle,
        modalSuccess: close,
        modalDenied: close,
        modalErr: close,
        modalwait: close,
      },
      setTextBody("")
    );
  };

  //Data Table {
  const [globalFilter, setGlobalFilter] = useState(null);
  ///sort && filter
  function filtered(data) {
    const filteredData = data.filter(
      (item) =>
        item.timestamp
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.license_start
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.license_end
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.user_data.f_name
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.user_data.l_name
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join(""))
    );
    return filteredData;
  }

  const renderHeader = () => {
    return (
      <div className="flex flex-wrap gap-2 justify-content-between align-items-center">
        <h4 className="m-0">ลงทะเบียนโดรน</h4>
        <IconField iconPosition="left">
          <InputText
            style={{ width: "auto" }}
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
            placeholder="🔍  ค้นหา..."
          />
        </IconField>
      </div>
    );
  };
  const header = renderHeader();

  const Body_Regist_Date = (data) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <MdDateRange />
        <div style={{ marginLeft: "2px" }}>
          {" "}
          {`${data.created_at.substring(0, 10)}` +
            " " +
            " " +
            " " +
            `${data.created_at.substring(11, 16)}`}
        </div>
      </div>
    );
  };
  const Body_Name = (data) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ textAlign: "left" }}>
          <FaUserAstronaut /> {data.user_data.title} {data.user_data.f_name}{" "}
          {data.user_data.l_name}
        </div>
      </div>
    );
  };
  const Body_Data_Cert = (data) => {
    return (
      <div
        style={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ marginLeft: "2px" }}>
          <MdDateRange /> {`${data.license_start.substring(0, 10)}`} -{" "}
          {`${data.license_end.substring(0, 10)}`}
        </div>
      </div>
    );
  };
  const Body_Status = (data) => {
    return (
      <div
        style={{
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
        }}
      >
        {" "}
        <Pilot_Status_Regulator status={data.status_label} />
      </div>
    );
  };
  const Body_Information = (data) => {
    return (
      <div>
        <p
          style={{ cursor: "pointer", margin: "auto" }}
          onClick={() => handleUserInfoClick(data)}
        >
          <img
            alt=""
            src={data.status === 2 ? fileicon : docgif}
            style={{
              width: data.status === 2 ? "36px" : "46px",
              height: data.status === 2 ? "36px" : "46px",
              background: data.status === 2 ? "none" : "red",
            }}
          />
        </p>
        {selectedUserData && (
          <Modal_MUI
            open={userInformation}
            onClose={() => {
              setUserInformation(false);
            }}
          >
            {selectedUserData ? (
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 500,
                  bgcolor: "background.paper",
                  boxShadow: 24,
                  p: 4,
                  borderRadius: 2,
                  maxHeight: "90vh",
                  overflowY: "auto",
                }}
              >
                <Typography
                  variant="h5"
                  component="h2"
                  gutterBottom
                  align="center"
                >
                  ข้อมูลผู้ใช้งาน
                </Typography>

                {/* General Information */}
                <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    ข้อมูลทั่วไป
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Typography>
                    <strong>ชื่อ:</strong> {selectedUserData.user_data.title}{" "}
                    {selectedUserData.user_data.f_name}{" "}
                    {selectedUserData.user_data.l_name}
                  </Typography>
                  <Typography>
                    <strong>วันเกิด:</strong>{" "}
                    {selectedUserData.user_data.birth_date} (
                    {selectedUserData.user_data.age} ปี)
                  </Typography>
                  <Typography>
                    <strong>สัญชาติ:</strong>{" "}
                    {selectedUserData.user_data.nationality}
                  </Typography>
                  <Typography>
                    <strong>อาชีพ:</strong>{" "}
                    {selectedUserData.user_data.occupation}
                  </Typography>
                </Paper>

                {/* Address Information */}
                <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    ที่อยู่
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Typography>
                    <strong>ที่อยู่ปัจจุบัน:</strong>{" "}
                    {selectedUserData.user_data.cur_address.cur_address}, ตำบล
                    {selectedUserData.user_data.cur_address.cur_sub_dis}, อำเภอ
                    {selectedUserData.user_data.cur_address.cur_dis}, จังหวัด
                    {selectedUserData.user_data.cur_address.cur_province},{" "}
                    {selectedUserData.user_data.cur_address.cur_poscode}
                  </Typography>
                  <Typography>
                    <strong>ที่อยู่ตามทะเบียนบ้าน:</strong>{" "}
                    {selectedUserData.user_data.address.address}, ตำบล
                    {selectedUserData.user_data.address.sub_dis}, อำเภอ
                    {selectedUserData.user_data.address.dis}, จังหวัด
                    {selectedUserData.user_data.address.province},{" "}
                    {selectedUserData.user_data.address.pos_code}
                  </Typography>
                </Paper>

                {/* License Information */}
                <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    ข้อมูลใบอนุญาต
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Typography>
                    <strong>ชื่อเอกสาร:</strong> {selectedUserData.license.name}
                  </Typography>
                  <Typography>
                    <strong>ประเภทไฟล์:</strong> {selectedUserData.license.type}
                  </Typography>
                  <Typography>
                    <strong>ขนาดไฟล์:</strong>{" "}
                    {(selectedUserData.license.size / 1024).toFixed(2)} KB
                  </Typography>
                  <Typography>
                    <strong>วันที่เริ่มต้นใบอนุญาต:</strong>{" "}
                    {selectedUserData.license_start}
                  </Typography>
                  <Typography>
                    <strong>วันที่หมดอายุใบอนุญาต:</strong>{" "}
                    {selectedUserData.license_end}
                  </Typography>
                  <Typography>
                    <strong>สถานะ:</strong> {selectedUserData.status_label}
                  </Typography>
                  <Form.Group as={Col} md="12">
                    <Form.Label
                      className="font-cen"
                      style={{ fontSize: "20px" }}
                    >
                      เอกสารแสดงตัวตน
                    </Form.Label>
                    <Form.Label className="font-cen">
                      ใบรับรอง
                      <span style={{ color: "red" }}>***</span>
                    </Form.Label>
                    <Row className="mb-3">
                      <Col md={10}>
                        <div
                          onClick={() => {
                            if (selectedUserData.license.path === null) {
                            } else {
                              handleGetFile_Cert(
                                selectedUserData.id,
                                selectedUserData.license.path
                              );
                            }
                          }}
                        >
                          <Form.Control
                            style={{ cursor: "pointer" }}
                            //disabled={open}
                            required
                            className="form-import-val"
                            type="text"
                            placeholder="No file Chosen....."
                            value={
                              selectedUserData.license === null
                                ? "No file Chosen....."
                                : selectedUserData.license.name
                            }
                            readOnly
                          />
                        </div>
                      </Col>
                    </Row>
                  </Form.Group>
                </Paper>

                {/* Action Buttons */}
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mt={3}
                  gap={2}
                >
                  {/* ปุ่มปิดชิดซ้าย */}
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => setUserInformation(false)}
                  >
                    ปิด
                  </Button>

                  {selectedUserData.status === 2 ? null : (
                    <Box display="flex" gap={2} alignItems="center">
                      <FormControl sx={{ minWidth: 120 }} size="small">
                        <InputLabel id="pilot-status-label">
                          สถานะนักบิน
                        </InputLabel>
                        <Select
                          labelId="pilot-status-label"
                          id="pilot-status"
                          value={selectedValueStatus}
                          label="สถานะนักบิน"
                          onChange={handleStatusChange}
                        >
                          {pilot_StatusObject.map(
                            (status) =>
                              status.pilot_status_id !== 1&& status.pilot_status_id !== 5 && (
                                <MenuItem
                                  key={status.pilot_status_id}
                                  value={status.pilot_status_id}
                                >
                                  {status.status_name}
                                </MenuItem>
                              )
                          )}
                        </Select>
                      </FormControl>
                      <TextField
                        required={needComment}
                        id="standard-basic"
                        label="comment"
                        variant="standard"
                        onChange={(e) => {
                          
                          if((selectedValueStatus === 3 || selectedValueStatus === 4)&& comment === null){
                            setNeedComment(true)

                          }else{
                            setNeedComment(false)
                          }
                          setComment(e.target.value);
                        }}
                      />

                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          if(needComment === true){

                          }else{
                            handlePilotStatusChange(
                            selectedUserData.id,
                            selectedValueStatus
                      
                          );
                          }
                          
                        }}
                      >
                        ยืนยัน
                      </Button>
                    </Box>
                  )}
                </Box>
              </Box>
            ) : null}
          </Modal_MUI>
        )}
      </div>
    );
  };
  function handlePilotStatusChange(id, status) {
    try {
      if (id && status) {
        Update_Pilot_Status(id, status,comment);
      }
    } catch (err) {
      handleClose_Modal();
      setTextBody(err.message || err.toString());
      setModalToggle({ ...modalToggle, modalErr: true });
    }
  }

  const handleUserInfoClick = (data) => {
    console.log(data);
    setSelectedUserData(data);
    setUserInformation(true);
  };

  const handleStatusChange = (event) => {
    console.log(event.target.value)
    if((event.target.value === 3 || event.target.value === 4)&& comment===null){
      setNeedComment(true)
    }else{
      setNeedComment(false)
    }
    setSelectedValueStatus(event.target.value);
  };

  // เอาฟังก์ชั่นนี้ไปใส่ใน elem ที่ต้องการได้เลยครับที่อยู่ใน Modal Body_Infomation แต่ยังไม่ได้เซ็ตรับ response.blob นะครับ   onClick={()=>handleGetFile_Cert(selectedUserData.id,selectedUserData.license.name)}
  function handleGetFile_Cert(id, filename) {
    try {
      if (id && filename) {
        Call_Cert_File(id, filename);
      }
    } catch (err) {
      handleClose_Modal();
      setTextBody(err.message || err.toString());
      setModalToggle({ ...modalToggle, modalErr: true });
    }
  }

  //Data Table }

  //Fetch Data
  async function CallService() {
    try {
      await RegulatorService.GetPilotLicenseData()
        .then((res) => {
          console.log(res.data);
          setData(res.data);
        })
        .catch((err) => {
          handleClose_Modal();
          setTextBody(err.message || err.toString());
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    } catch (err) {
      handleClose_Modal();
      setTextBody(err.message || err.toString());
      setModalToggle({ ...modalToggle, modalErr: true });
    }
  }
  async function Pilot_Status(status) {
    try {
      await RegulatorService.GetPilot_Status(status)
        .then((res) => {
          console.log(res.data.data)
          setPilot_StatusObject(res.data.data);
        })
        .catch((err) => {
          handleClose_Modal();
          setTextBody(err.message || err.toString());
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    } catch (err) {
      handleClose_Modal();
      setTextBody(err.message || err.toString());
      setModalToggle({ ...modalToggle, modalErr: true });
    }
  }
  async function Update_Pilot_Status(id, status,comment) {
    try {
      await RegulatorService.UpdatePilotRegistStatus(id, status,comment)
        .then((res) => {
          setComment(null)
          setSelectedValueStatus("")
          handleClose_Modal();
          setModalToggle({ ...modalToggle, modalSuccess: true });
          if (res.data.status === "success") {
            handleClose_Modal();
            setModalToggle({ ...modalToggle, modalSuccess: true });
          } else {
            handleClose_Modal();
            setTextBody("An unexpected error occurred.");
            setModalToggle({ ...modalToggle, modalErr: true });
          }
        })
        .catch((err) => {
          handleClose_Modal();
          setTextBody(err.message || err.toString());
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    } catch (err) {
      handleClose_Modal();
      setTextBody(err.message || err.toString());
      setModalToggle({ ...modalToggle, modalErr: true });
    }
  }
  async function Call_Cert_File(id, filename) {
    console.log(id, filename);
    try {
      await RegulatorService.Certificate_File(id, filename)
        .then((res) => {
          const file = new Blob([res.data], { type: res.data.type });
          const fileUrl = URL.createObjectURL(file);
          //setFileUrl(fileUrl);
          window.open(fileUrl, "_blank");
          // pdfWindow.document.write(
          //   `<iframe src="${fileUrl}" width="100%" height="100%"></iframe>`
          // );
        })

        .catch((err) => {
          handleClose_Modal();
          setTextBody(err.message || err.toString());
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    } catch (err) {
      handleClose_Modal();
      setTextBody(err.message || err.toString());
      setModalToggle({ ...modalToggle, modalErr: true });
    }
  }
  useEffect(() => {
    Pilot_Status();
    // CallService();
    const intervalId = setInterval(() => {
      CallService();
    }, 5000); // 1000 ms = 1 second
    return () => {
      clearInterval(intervalId);
    };
  }, []);
  return (
    <div className="container-main" style={{ width: "90%", marginLeft: "5%" }}>
      <div
        className="table-card-header"
        style={{
          color: "white",
          background: "linear-gradient(90deg, #b1bcc4b5 0%, #edf3f5 100%)",
        }}
      >
        <h4 className="header-main" style={{ color: "rgb(78 85 90)" }}>
          รายการคำขอขึ้นทะเบียนนักบินทั้งหมด
        </h4>
      </div>

      <div>
        <div style={{ textAlign: "end", marginTop: "35px" }}>
          <p>จำนวน {data.length ? data.length : 0} รายการ</p>
        </div>

        <DataTable
          value={globalFilter ? filtered(data) : data}
          paginator
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          rows={5}
          rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
          header={header}
          emptyMessage="ไม่พบข้อมูล"
          tableStyle={{ minWidth: "50rem" }}
          style={{ fontFamily: "Kanit" }}
        >
          <Column
            header="วันที่ขอขึ้นทะเบียน"
            body={Body_Regist_Date}
            field={`timestamp`}
            sortable
            filterField="registration_date"
            dataType="date"
            bodyStyle={{ alignItems: "center", textAlign: "center" }}
            style={{ width: "12%" }}
          ></Column>
          <Column
            header={`ชื่อ-นามสกุล`}
            body={Body_Name}
            field={"user_data.f_name" && "user_data.l_name"}
            sortable
            bodyStyle={{ alignItems: "center", textAlign: "center" }}
            style={{ width: "15%" }}
          ></Column>

          <Column
            header="เริ่มต้น-สิ้นสุด ใบอนุญาต"
            body={Body_Data_Cert}
            field={"license_start" && "license_end"}
            sortable
            bodyStyle={{ textAlign: "center" }}
            style={{ width: "20%" }}
          ></Column>
          <Column
            header="สถานะ"
            sortable
            field={"status"}
            body={Body_Status}
            bodyStyle={{ textAlign: "center" }}
            style={{ width: "10%" }}
          ></Column>
          <Column
            header="รายละเอียด"
            body={Body_Information}
            sortable
            bodyStyle={{ textAlign: "center" }}
            style={{ width: "10%" }}
          ></Column>
        </DataTable>

        <Static_modal
          modalwaiting={modalToggle.modalwait}
          modalErr={modalToggle.modalErr}
          modalSuccess={modalToggle.modalSuccess}
          modalDenied={modalToggle.modalDenied}
          textBody={textBody}
          getHandle={handleClose_Modal}
        />
      </div>
    </div>
  );
}
